import makeStyles from '@material-ui/core/styles/makeStyles';
import { ISpcTheme } from '../../../../common/theme/ISpcTheme';

export type NavigationBarClasses =
  | 'container'
  | 'changeModelLinkContainer'
  | 'buttonsContainer'
  | 'navigationMyAccountCTA'
  | 'myAccountContainer'
  | 'changeLinkContainerCustomize'
  | 'promotionalLabel'
  | 'containerVariantsPage';

const navigationBarStyles = makeStyles<ISpcTheme, NavigationBarClasses>(
  theme => ({
    container: {
      position: 'sticky',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 42,
      whiteSpace: 'nowrap',
      textAlign: 'center',
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.text.primary,
      paddingRight: 15,
      [theme.breakpoints.down('md')]: {
        padding: '8px 0 8px 0',
      },
    },
    changeModelLinkContainer: {
      left: '30px',
      position: 'absolute',
      top: '15px',
      zIndex: 99,
      [theme.breakpoints.down('md')]: {
        position: 'unset',
        overflowX: 'auto',
        backgroundColor: theme.palette.primary.main,
        height: 36,
        display: 'flex',
        justifyContent: 'center',
      },
    },
    changeLinkContainerCustomize: {},
    buttonsContainer: {
      overflowX: 'auto',
    },
    navigationMyAccountCTA: {
      zIndex: 99,
    },
    myAccountContainer: {
      top: 0,
      right: 25,
      position: 'absolute',
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      [theme.breakpoints.down('md')]: {
        position: 'static',
      },
    },
    promotionalLabel: {
      display: 'flex',
      backgroundColor: theme.palette.primary.dark,
      justifyContent: 'center',
      padding: '10px 0',
      color: theme.palette.common.white,
    },
    containerVariantsPage: {},
  }),
  { name: 'Customise_NavigationBar' },
);

export default navigationBarStyles;
